import {Vendor} from 'pwm-shared';
import React, {useEffect} from 'react';
import {Dialog, DialogActions, DialogTitle, IconButton, Paper} from '@mui/material';
import {downloadFile} from '../utils/download-file';
import PdfViewerUrlComponent from './PdfViewerUrlComponent';
import SlideTransitionComponent from './SlideTransitionComponent';
import {useTranslation} from 'react-i18next';
import {PWMPdfIcon} from './PWMIcons';
import {ButtonSecondary} from './PWMButtons';

const PDFViewer: React.FC<IPdfViewerProps> = (props) => {
  const [page, setPage] = React.useState<number>(1);
  const {t} = useTranslation();
  useEffect(() => setPage(1), [props.fileUrl]);

  const downloadPdf = (e: any) => {
    e?.preventDefault();
    downloadFile(props.fileUrl, props.fileName);
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      TransitionComponent={SlideTransitionComponent}
      maxWidth="xl"
      fullWidth={true}
      aria-labelledby="pdfViewer"
    >
      <DialogTitle id="pdfViewer">{t('interface.verificationpdf')}</DialogTitle>
      <Paper>
        {props.contentUrl && <PdfViewerUrlComponent url={props.contentUrl} />}
      </Paper>
      <DialogActions>
        <IconButton onClick={downloadPdf}><PWMPdfIcon /></IconButton>
        <ButtonSecondary onClick={props.onClose}>Close</ButtonSecondary>
      </DialogActions>
    </Dialog>
  )
};

interface IPdfViewerProps {
  isOpen: boolean;
  fileUrl: string;
  contentUrl?: string;
  fileName: string;
  message?: string;
  log: Vendor.ILogData[];
  onClose(): any;
}

export default PDFViewer;